import PropTypes from 'prop-types';
import { createPrefixedActionFactory } from './actionUtils';

const prefix = 'SESSION';
const createAction = createPrefixedActionFactory(prefix);

export const init = createAction({
  type: 'INIT',
  propTypes: {},
});

export const setUser = createAction({
  type: 'SET_USER',
  propTypes: {
    user: PropTypes.array,
  },
});

export const accessTokenSuccess = createAction({
  type: 'ACCESS_TOKEN_SUCCESS',
  propTypes: {
    accessToken: PropTypes.string.isRequired,
  },
});

export const fullOrganizationSuccess = createAction({
  type: 'FULL_ORGANIZATION_SUCCESS',
  propTypes: {
    full: PropTypes.object.isRequired,
  },
});

export const updateStep = createAction({
  type: 'UPDATE_STEP',
  propTypes: {
    step: PropTypes.string.isRequired,
  },
});

export const goBack = createAction({
  type: 'GO_BACK',
  propTypes: {},
});

export const sideMenuDisplay = createAction({
  type: 'SIDE_MENU_DISPLAY',
  propTypes: {
    value: PropTypes.bool.isRequired,
  },
});

export const fetchBranches = createAction({
  type: 'FETCH_BRANCHES',
  propTypes: {
    chainId: PropTypes.string.isRequired,
  },
});

export const fetchBranchesSuccess = createAction({
  type: 'FETCH_BRANCHES_SUCCESS',
  propTypes: {
    organizations: PropTypes.array.isRequired,
  },
});

export const fetchBranchesFailure = createAction({
  type: 'FETCH_BRANCHES_FAILURE',
  propTypes: {},
});

export const clearBranches = createAction({
  type: 'CLEAR_BRANCHES',
  propTypes: {},
});

export const selectBranch = createAction({
  type: 'SELECT_BRANCH',
  propTypes: {
    branchId: PropTypes.string.isRequired,
  },
});

export const indicateFetchOrganization = createAction({
  type: 'INDICATE_FETCH_ORGANIZATION',
  propTypes: {},
});

export const toggleCustomerDetailsSummary = createAction({
  type: 'TOGGLE_CUSTOMER_DETAILS_SUMMARY',
  propTypes: {},
});

export const displayCustomerDetailsSummary = createAction({
  type: 'DISPLAY_CUSTOMER_DETAILS_SUMMARY',
  propTypes: {},
});

export const hideCustomerDetailsSummary = createAction({
  type: 'HIDE_CUSTOMER_DETAILS_SUMMARY',
  propTypes: {},
});

export const accessTokenError = createAction({
  type: 'ACCESS_TOKEN_ERROR',
  propTypes: {
    error: PropTypes.any,
  },
});

export const fullOrganizationError = createAction({
  type: 'FULL_ORGANIZATION_ERROR',
  propTypes: {
    error: PropTypes.any,
  },
});

export const badPhone = createAction({
  type: 'BAD_PHONE',
  propTypes: {
    error: PropTypes.any,
  },
});

export const setAssociateDishPaymentIndex = createAction({
  type: 'SET_ASSOCIATE_DISH_PAYMENT_INDEX',
  propTypes: {
    associateDishPaymentIndex: PropTypes.number.isRequired,
  },
});

export const clearAssociateDishPaymentIndex = createAction({
  type: 'CLEAR_ASSOCIATE_DISH_PAYMENT_INDEX',
  propTypes: {},
});

export const displayModal = createAction({
  type: 'DISPLAY_MODAL',
  propTypes: {
    modal: PropTypes.string.isRequired,
  },
});

export const hideModal = createAction({
  type: 'HIDE_MODAL',
  propTypes: {
    modal: PropTypes.string.isRequired,
  },
});

export const toggleModal = createAction({
  type: 'TOGGLE_MODAL',
  propTypes: {
    modal: PropTypes.string.isRequired,
  },
});

export const clearCustomerSession = createAction({
  type: 'CLEAR_CUSTOMER_SESSION',
  propTypes: {
    step: PropTypes.string,
  },
});

export const pushToHistoryStack = createAction({
  type: 'PUSH_TO_HISTORY_STACK',
  propTypes: {
    step: PropTypes.string.isRequired,
  },
});

export const popFromHistoryStack = createAction({
  type: 'POP_FROM_HISTORY_STACK',
  propTypes: {},
});

export const goToSettings = createAction({
  type: 'GO_TO_SETTINGS',
  propTypes: {},
});

export const setMsid = createAction({
  type: 'SET_MSID',
  propTypes: {
    msid: PropTypes.string.isRequired,
  },
});

export const reportCustomerInformationContinueAttempt = createAction({
  type: 'REPORT_CUSTOMER_INFORMATION_CONTINUE_ATTEMPT',
  propTypes: {
    errorField: PropTypes.string,
    isError: PropTypes.bool,
    isNewCustomer: PropTypes.bool,
  },
});

export const goToRolesAndPermissions = createAction({
  type: 'GO_TO_ROLES_AND_PERMISSIONS',
});

export const setFirstTime = createAction({
  type: 'SET_FIRST_TIME',
  propTypes: {
    value: PropTypes.bool,
  },
});

export const navigateAwayModalClose = createAction({
  type: 'NAVIGATE_AWAY_MODAL_CLOSE',
  propTypes: {
    shouldResumeNavigation: PropTypes.bool,
  },
});

export const setInstance = createAction({
  type: 'SET_INSTANCE',
  propTypes: {
    signedInstance: PropTypes.string,
    fallbackSignedInstance: PropTypes.string,
  },
});
